import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { ApiConnectionService } from 'src/app/services/api-connection.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppComponent } from 'src/app/app.component';
import { HomeService } from 'src/app/services/home/home.service';
import { ProfileService } from 'src/app/services/user/profile.service';

declare const $: any;
declare const gtag: any;

@Component({
  selector: 'app-register-construction-project',
  templateUrl: './register-construction-project.component.html',
  styleUrls: ['./register-construction-project.component.css'],
})
export class RegisterConstructionProjectComponent implements OnInit {
  image: any = null;

  // Google maps and location
  address: any;
  selected: any;
  searchControl: FormControl;
  lat = 4.123566;
  lng = -5.1564897;
  zoom: number;
  private geoCoder;
  locationConfirmed = false;
  zone = null;
  city = null;
  complement: any;
  habitaciones: number = 0;
  banos: number = 0;
  parqueaderos: number = 0;
  balcones: number = 0;
  ascensores: number = 0;
  terrazas: number = 0;
  depositos: number = 0;

  // Property items set
  id: any = '';
  slug: any = '';
  slugProject: any = '';
  token: any = '';
  type_property: any = [];
  type_properties = [];
  currencies: Array<any> = [];
  currency: String = localStorage.getItem('currency') ?? 'COP';
  currentCurrency: String = localStorage.getItem('currency') ?? 'COP';
  type_offer: any = 'venta';
  administration: any = '';
  administration_value: any;
  antiguedad: number = 0;
  planes: any;

  sites = [];
  nearby_site = null;
  characteristicsIndex = [
    { name: 'Interiores', index: 'interiors', identifier: 'interiores' },
    { name: 'Exteriores', index: 'exterior', identifier: 'exteriores' },
    { name: 'Zonas comunes', index: 'common_zones', identifier: 'comunes' },
  ];
  characteristics = {};
  value = '';
  step = 1;
  description = '';
  interiorarrow = true;
  exteriorarrow = true;
  comunarrow = true;
  currencyPlaceholder: any = 'Peso colombiano';
  // Cropper
  file: any = '';
  croppedEdit: any = '';
  imageChangedEvent: any = [];
  croppedImage: any = '';
  croppedImages: any = [];
  transform: ImageTransform = {};
  canvasRotation = 0;
  scale = 1;
  rotation = 0;

  //errors
  errorArea: boolean = false;
  errorCiudad: boolean = false;
  errorValor: boolean = false;
  errorEstado: boolean = false;
  errorEstrato: boolean = false;
  errorOferta: boolean = false;
  errorInmueble: boolean = false;
  errorZona: boolean = false;
  errorImages: boolean = false;

  public aspectRadio: any = 16 / 9;
  public resolutions: any = [
    { value: 16 / 10, name: '16/10 -> Home Vivienda' },
    { value: 16 / 9, name: '16/9 -> Home Vivienda' },
    { value: 9 / 16, name: '9/16 -> Instagram Vertical (Rectangular)' },
    { value: 5 / 4, name: '5/4 -> Post Facebook' },
    { value: 4 / 5, name: '4/5 -> Instagram Vertical (Autoajuste)' },
    { value: 4 / 3, name: '4/3 -> Cuadrado' },
    { value: 3 / 2, name: '3/2 -> Cuadrado (2)' },
    { value: 1 / 1, name: '1/1 -> Rectangular Vertical' },
  ];
  resizeWidth: any;
  resizeHeight: any;

  estrato;
  estado: string = '';
  tipovivienda: any = '';
  floors;
  antiquity;
  area: any = {
    total: null,
    private: null,
  };

  steps = [false, false, false, false];

  saved: boolean = false;
  edit: boolean = false;
  status: number = 5;

  contacts = [
    {
      name: '',
      email: '',
      phones: [
        {
          phone: '',
          accept: {
            phone: false,
            whatsapp: false,
          },
        },
      ],
    },
  ];
  chselected: any = {
    ch: {},
    value: '',
    name: '',
    counter: '',
    multiple: [{ name: '' }],
  };

  @ViewChild('search')
  public searchElementRef: ElementRef;

  browser = false;
  urlVideo = null;

  profiles: any = {};
  project: any = {};
  constructor(
    protected mapsAPILoader: MapsAPILoader,
    protected ngZone: NgZone,
    protected http: ApiConnectionService,
    protected route: ActivatedRoute,
    protected app: AppComponent,
    protected homeService: HomeService,
    protected profileService: ProfileService,
    protected apiService: ApiConnectionService,
    @Inject(PLATFORM_ID) platformBrowser: string
  ) {
    this.browser = isPlatformBrowser(platformBrowser);
    this.route.params.subscribe(
      (v) => ((this.slug = v.slug), (this.slugProject = v.projectSlug))
    );
  }

  ngOnInit(): void {
    this.getConstructora();
    this.init();
    this.searchControl = new FormControl();

    this.mapsAPILoader.load().then(() => {
      this.setCurrentPosition();
      // tslint:disable-next-line:new-parens
      this.geoCoder = new google.maps.Geocoder();

      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement
      );
      autocomplete.addListener('place_changed', () => {
        this.address = null;
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          console.log(place);

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.address = place.formatted_address;
          $('#address').val(this.address);
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 24;
          place.address_components.forEach((v, i) => {
            const indexNeighbordhood = v.types.indexOf('neighborhood');
            if (indexNeighbordhood > -1) {
              this.zone = v.long_name;
            }

            const indexLocality = v.types.indexOf(
              'administrative_area_level_1'
            );
            if (indexLocality > -1) {
              this.city = v.long_name;
            }

            const index = v.types.indexOf('country');
            if (index > -1) {
              const name = v.long_name;
              const indexOf = this.currencies.findIndex(
                (v) => v.countries.indexOf(name) > -1
              );
              if (indexOf > -1) {
                this.currency = this.currencies[indexOf].iso;
              }
            }
          });
        });
      });
    });
  }
  init() {
    this.http.postData('properties', {}, {}).subscribe(
      (response: any) => {
        this.type_properties = response.properties;
        this.currencies = response.currencies;
      },
      (error: any) => this.homeService.parseErrorResponse(error)
    );

    if (this.browser) {
      let params = new URLSearchParams(window.location.search);
      params.delete('paso');
      let concat = '';
      if (params.toString().length > 0) {
        concat += '?' + params.toString();
      }
      window.history.pushState({}, '', window.location.pathname + concat);
    }
  }
  getConstructora() {
    this.apiService.getData('profile/' + this.slug, { auth: false }).subscribe(
      (response) => {
        this.profiles = response;

        if (this.profiles.type != 'Empresa constructora')
          window.location.href = `/usuario/perfil/${this.slug}`;

        this.getProyecto();
      },
      (error) => {
        window.location.href = '/usuario/perfil';
      }
    );
  }

  getProyecto() {
    this.apiService
      .getData('profile/' + this.slug + '/projects/' + this.slugProject, {
        auth: false,
      })
      .subscribe(
        (response) => {
          this.project = response;
        },
        (error) => {
          window.location.href = '/usuario/perfil';
        }
      );
  }

  fileChangeEvent(event: any, location: string = ''): void {
    let lengthImages = this.croppedImages.length;
    for (var i = 0; i < event.target.files.length; i++) {
      let type = event.target.files[i].type.split('/');
      if (
        this.isAvailableImageFormat(type[1]) &&
        event.target.files[i].size < 3500000 &&
        lengthImages < 20
      ) {
        this.imageProcess(event, event.target.files[i], location);
        lengthImages++;
      } else {
        this.errorImages = true;
      }
    }
  }

  imageProcess(event: any, file: any, type: string) {
    //Setting images in our required format
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.croppedImages.push({
        original: reader.result,
        cropped: reader.result,
        event: file,
        type: 'image',
        data: type,
        area_construida:'',
        area_aa:'',
        area_privada:''
      });
    };
  }

  isAvailableImageFormat(format): boolean {
    const formats = ['jpeg', 'jpg', 'png', 'jpe', 'jfif'];
    return formats.includes(format);
  }
  
  editCroppedImage(item: any, index: any): any {
    const event = {
      target: {
        files: [item.event]
      }
    };
    this.imageChangedEvent[0] = event;
    this.imageChangedEvent[1] = event;
    this.croppedEdit = index;
  }

  cropperReady() {
    return true;
  }

  imageCropped(event: ImageCroppedEvent, image, type) {
    if (!this.croppedImages[this.croppedEdit].images) {
      this.croppedImages[this.croppedEdit].images = [];
    }
    this.croppedImages[this.croppedEdit].images[image] = {
      image: event.base64,
      type: type
    };

    if (image == 0){
      this.croppedImages[this.croppedEdit].cropped = event.base64;
    }

    console.log(this.croppedImages);
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  cancelCropper() {
    this.croppedImage = '';
    this.imageChangedEvent = [];
  }

  useCropper(event = []): void {
    this.croppedImage = '';
    this.imageChangedEvent = event;
    this.croppedEdit = '';
    this.resetImage;
  }
  form(f) {
    if (f.form.status == 'VALID') {
      Swal.fire({
        title: 'Estamos guardando tu inmueble',
        html:
          '<img src="/assets/img/sandclock.gif" class="d-block m-auto mb-2" style="filter: opacity(0.5);" />' +
          '<p id="sweet-alert-text-html">Estamos almacenando los datos preliminares de tu proyecto, espera un momento.<p> ',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      });
      let body = {
        type_property: f.value['type'],
        type_offer: this.type_offer,
        location: {
          latitude: this.lat,
          longitude: this.lng,
          address: this.address,
          city: this.city,
          zone: this.zone,
        },
        estrato: f.value['estrato'],
        status: this.estado,
        value: parseInt(this.value.replace(/\D/g, ''), 10),
        currency: this.currency,
        area: this.area,
      };

      this.preSaveForm(body);
    } else {
      var html =
        '<p class="pb-1">Te falta completar unos espacios para poder continuar con la publicación de tu inmueble:</p>';
      html += '<ul class="list-group text-left" style="padding-left: 15%;">';
      let array = [];
      console.log(f.form.controls);
      //console.log(f.form.controls.city);

      if (f.form.controls.area?.errors) this.errorArea = true;
      if (f.form.controls.city?.errors) this.errorCiudad = true;
      if (f.form.controls.currency_value?.errors) this.errorValor = true;
      if (f.form.controls.estado?.errors) this.errorEstado = true;
      if (f.form.controls.estrato?.errors) this.errorEstrato = true;
      if (f.form.controls.offer?.errors) this.errorOferta = true;
      if (f.form.controls.type?.errors) this.errorInmueble = true;
      if (f.form.controls.zone?.errors) this.errorZona = true;

      for (var i in f.form.controls)
        if (f.form.controls[i].errors)
          html +=
            '<li class="list-group-item text-danger" style="border:none!important;"><i class="fas fa-times"></i> El campo ' +
            this.translateWord(i) +
            ' es requerido</li>';
      if (this.croppedImages.length <= 0)
        html +=
          '<li class="list-group-item text-danger" style="border:none!important;"><i class="fas fa-times"></i> Debes agregar mínimo 1 imagen para tu inmueble</li>';
      html += '</ul>';
      Swal.fire({
        title: 'Algo salió mal...',
        html: html,
        imageUrl: 'https://cdn.vivienda.com/images/icons/imagen-error.png',
        confirmButtonColor: '#f7bf50',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        this.scrollTop();
      });
    }
  }

  translateWord(word) {
    const words = {
      address: 'Dirección',
      city: 'Ciudad',
      currency_value: 'Valor',
      offer: 'Tipo de Oferta',
      zone: 'Zona',
      currency: 'Moneda',
      type: 'Tipo de inmueble',
    };
    return words[word]
      ? words[word]
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
  scrollTop(): void {
    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 8);
      }
    };
    scrollToTop();
  }
  preSaveForm(body): void {
    if (!this.saved) {
      this.http.postData('property', body, { auth: true }).subscribe(
        (response) => {
          this.saved = true;
          this.id = response.data.property.id;
          this.token = response.data.property.token;
          this.profiles = response.data.profiles;
          this.assign();
        },
        (error) => {
          sessionStorage.setItem('property', JSON.stringify(body));
        }
      );
    } else {
      this.assign();
    }
  }
  secondSaveStep() {
    if (this.croppedImages.length <= 0) {
      var html =
        '<p class="pb-1">Te falta completar unos espacios para poder continuar con la publicación de tu inmueble:</p>';
      html += '<ul class="list-group text-left" style="padding-left: 15%;">';
      if (this.croppedImages.length <= 0)
        html +=
          '<li class="list-group-item text-danger" style="border:none!important;"><i class="fas fa-times"></i> Debes agregar mínimo 1 imagen para tu inmueble</li>';
      html += '</ul>';
      Swal.fire({
        title: 'Algo salió mal...',
        html: html,
        imageUrl: 'https://cdn.vivienda.com/images/icons/imagen-error.png',
        confirmButtonColor: '#f7bf50',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        this.scrollTop();
      });
      return;
    }

    this.saveForm();

    let params = new URLSearchParams(window.location.search);
    let path = window.location.pathname + '?' + params.toString();

    setTimeout(() => {
      gtag('event', 'page_view');
      gtag('config', 'G-J2E7YSM5QZ', {
        page_title: 'Registro de proyectos de constructora',
        page_path: path,
      });
    }, 1000);
  }
  assign() {
    this.http
      .postData(
        'property/assign/' + this.token + '/' + this.slug,
        { project: this.slugProject },
        { auth: true }
      )
      .subscribe(
        (response) => {
          this.secondSaveStep();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  saveForm(): void {
    var interval,
      timeout = null;
    const html =
      '<div class="progress mt-4"><div class="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="0" aria-valuemin="0" id="progress-bar-sweet-alert" aria-valuemax="100" style="width: 0%"></div></div>';
    Swal.fire({
      title: 'Estamos guardando tu inmueble',
      html:
        '<p id="sweet-alert-text-html">Estamos almacenando los datos preliminares de tu inmueble, espera un momento.<p> ' +
        html,
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        var progress = 0;
        const min = this.croppedImages.length > 3 ? 1 : 5;
        const max = this.croppedImages.length > 3 ? 7 : 10;
        interval = setInterval(
          () => {
            progress += Math.floor(Math.random() * (min - max)) + max;
            $('#progress-bar-sweet-alert').css('width', progress + '%');
            if (progress >= 85) {
              $('#progress-bar-sweet-alert').css('width', '90%');
              clearInterval(interval);
            }
          },
          this.croppedImages.length > 2 ? 1500 : 2200
        );
        timeout = setTimeout(() => {
          progress = progress < 25 ? 25 : progress;
          $('#swal2-title').text('Tus imágenes se están subiendo');
          $('#sweet-alert-text-html').text(
            'En unos instantes podrás visualizar todas las fotos que seleccionaste y podrás completar la publicación de tu inmueble.'
          );
          timeout = setTimeout(
            () => {
              progress = progress < 50 ? 50 : progress;
              $('#swal2-title').text('Tus imágenes se están optimizando');
              $('#sweet-alert-text-html').text(
                'Para mejorar una mejor experiencia de usuario estamos generando tus imágenes con una calidad acorde a los lineamientos de vivienda.com.'
              );
              timeout = setTimeout(
                () => {
                  progress = progress < 75 ? 75 : progress;
                  $('#swal2-title').text(
                    'Estamos aplicando los últimos ajustes de visualización'
                  );
                  $('#sweet-alert-text-html').text(
                    'Estamos mejorando tus datos para mostrarlos de forma correcta en el detalle.'
                  );
                },
                this.croppedImages.length > 2 ? 5000 : 8000
              );
            },
            this.croppedImages.length > 2 ? 5000 : 8000
          );
        }, 5000);
      },
    });
    var data = {
      type_property: this.type_property,
      type_offer: this.type_offer,
      location: {
        latitude: this.lat,
        longitude: this.lng,
        address: this.address,
        city: this.city,
        zone: this.zone,
      },
      value: parseInt(this.value.replace(/\D/g, ''), 10),
      options: {
        areas: this.area,
        floors: this.floors,
        antiquity: this.antiquity,
      },
      images: this.croppedImages,
      description: this.description,
      status_id: this.status,
      status: this.estado,
      sites: this.sites,
      contacts: this.contacts,
      characteristics: {interiors:[
        {
          config: {
            display_name: 'Tipo de vivienda',
            identifier: 'tipovivienda',
            type: 'string',
            value: this.tipovivienda,
          },
          image: '',
          name: 'Tipo de vivienda',
          slug: 'tipovivienda',
        },
        {
          config: {
            display_name: 'Habitaciones',
            identifier: 'habitaciones',
            type: 'counter',
            value: this.habitaciones,
          },
          image: '',
          name: 'Habitaciones',
          slug: 'habitacion',
        },
        {
          config: {
            display_name: 'Ba\u00f1os',
            identifier: 'banos',
            type: 'counter',
            value: this.banos,
          },
          image: '',
          name: 'Ba\u00f1os',
          slug: 'bano',
        },
        {
          config: {
            display_name: 'Parqueaderos',
            identifier: 'parqueaderos',
            type: 'counter',
            value: this.parqueaderos,
          },
          image: '',
          name: 'Parqueaderos',
          slug: 'parqueadero',
        },
        {
          config: {
            display_name: 'Balcones',
            identifier: 'balcones',
            type: 'counter',
            value: this.balcones,
          },
          image: '',
          name: 'Balcones',
          slug: 'balcones',
        },
        {
          config: {
            display_name: 'Ascensores',
            identifier: 'ascensores',
            type: 'counter',
            value: this.ascensores,
          },
          image: '',
          name: 'Ascensores',
          slug: 'ascensores',
        },
        {
          config: {
            display_name: 'Terrazas',
            identifier: 'terrazas',
            type: 'counter',
            value: this.terrazas,
          },
          image: '',
          name: 'Terrazas',
          slug: 'terrazas',
        },
        {
          config: {
            display_name: 'Depositos',
            identifier: 'depositos',
            type: 'counter',
            value: this.depositos,
          },
          image: '',
          name: 'Depositos',
          slug: 'depositos',
        },
      ],}
    };
    this.http.putData('property/' + this.id, data, { auth: true }).subscribe(
      (response: any) => {
        $('#progress-bar-sweet-alert').css('width', '100%');
        if (interval) {
          clearInterval(interval);
        }
        if (timeout) {
          clearTimeout(timeout);
        }
        if (
          (this.profiles.companies && this.profiles.companies.length > 0) ||
          (this.profiles.agent && this.profiles.agent.slug)
        ) {
          if (response.data?.property.slug) {
            this.slug = response.data.property.slug;
          }
          $('form.tab').removeClass('d-block');
          $('#asignacion').removeClass('collapse');

          Swal.close();
          window.location.href = '/propiedad/registrar/gracias-constructora';
        } else {
          Swal.fire('¡Proyecto guardado correctamente!', '', 'success').then(
            () => {
              if (response.data?.property.slug) {
                Swal.fire({
                  title: 'Comparte en redes sociales tu inmueble',
                  confirmButtonText: 'Continuar',
                  html: `
                  <div class="d-flex m-auto text-center justify-content-center">
                    <a href="https://www.facebook.com/sharer.php?u=https://vivienda.com/propiedad/${response.data.property.slug}">
                      <img src="//cdn.vivienda.com/images/icons/facebook.png" class="img-fluid px-3" />
                    </a>
                    <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://vivienda.com/propiedad/${response.data.property.slug}">
                      <img src="//cdn.vivienda.com/images/icons/linkedin.png" class="img-fluid px-3" />
                    </a>
                  </div>
                  `,
                }).then(() => {
                  //window.location.href = '/usuario/perfil?tab=propiedades';
                  window.location.href = '/propiedad/registrar/gracias';
                });
              } else {
                window.location.href = '/propiedad/registrar/gracias';
              }
            }
          );
        }
      },
      (error: any) => {
        if (interval) {
          clearInterval(interval);
        }
        if (timeout) {
          clearTimeout(timeout);
        }
        Swal.fire({
          title:
            'En este momento no podemos atender tu solicitud, inténtalo más tarde',
          icon: 'warning',
        });
      }
    );
  }
  hasVideoItem() {
    let data = false;
    this.croppedImages.forEach((v) => {
      if (v.type == 'video') data = true;
    });
    return data;
  }
  // tslint:disable-next-line:typedef
  markerDragEnd($event: any) {
    this.lat = $event.latLng.lat();
    this.lng = $event.latLng.lng();
    this.getAddress(this.lat, this.lng);
  }

  // tslint:disable-next-line:typedef
  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 24;
            this.address = results[0].formatted_address;
            $('#address').val(this.address);
            results[0].address_components.forEach((v, i) => {
              v.types.forEach((f, j) => {
                if (f == 'neighborhood') {
                  this.zone = v.long_name;
                }
                if (f == 'locality') {
                  this.city = v.long_name;
                }
              });
            });
          } else {
            Swal.fire({
              title:
                'Esta localización está fuera de rango, por favor intenta con otra',
              icon: 'warning',
            }).then(() => {
              $('#address').val('');
              this.zone = '';
              this.address = '';
            });
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      }
    );
  }
  changePosition(index) {
    var array = this.croppedImages;
    if (0 >= array.length) {
      var k = 0 - array.length + 1;
      while (k--) {
        array.push(undefined);
      }
    }
    array.splice(0, 0, array.splice(index, 1)[0]);
    this.croppedImages = array;
  }
  // tslint:disable-next-line:typedef
  setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 24;
        this.getAddress(this.lat, this.lng);
      });
    }
  }

  //placehorder of value input
  getSelectedValue(event: any) {
    this.currencyPlaceholder =
      event.target.options[event.target.options.selectedIndex].title;
  }
}
